<template lang="html">
  <div id="app">
    <nav class="uk-navbar-container">
        <div class="uk-navbar-left">
            <ul class="uk-navbar-nav">
                <li class="uk-active"><router-link to="/"><b>Vue-universal-modal</b></router-link></li>
                <li class=""><router-link to="/docs">Docs</router-link></li>
                <li class=""><router-link to="/props">Props</router-link></li>
                <li class=""><router-link to="/examples">Examples</router-link></li>
                <li><a target="_blank" href="https://github.com/vuNemesis/vue-universal-modal"><span uk-icon="github"></span></a></li>
            </ul>
        </div>
    </nav>
    <page-content/>
    <modal-wrapper/>
  </div>
</template>

<script>
import { ModalWrapper } from 'src'
export default {
  name: 'app',
  components: {
    ModalWrapper
  }
}
</script>

<style lang="scss" src="./assets/scss/main.scss"></style>



// WEBPACK FOOTER //
// App.vue?7573aa2a